import React from 'react';
import styles from './ContentSection.module.scss';

interface ContentSectionProps {
  children: React.ReactNode;
  variant?: 'default' | 'highlight' | 'subtle';
  spacing?: 'normal' | 'compact' | 'spacious';
  className?: string;
}

export default function ContentSection({ 
  children, 
  variant = 'default',
  spacing = 'normal',
  className = ''
}: ContentSectionProps) {
  const classes = [
    styles.contentSection,
    styles[`variant-${variant}`],
    styles[`spacing-${spacing}`],
    className
  ].filter(Boolean).join(' ');

  return (
    <section className={classes}>
      {children}
    </section>
  );
}